export default __webpack_public_path__ + "static/media/5-icon.6654cfc3.svg";